var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleGeminiProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -158.6776,
    cy: 154.4212,
    r: 4.8,
    gradientTransform: "matrix(20.1657 6.8191 54.6255 -161.54 -5225.9561 26066.2637)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671246,
    style: {
      stopColor: "#9168C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3426,
    style: {
      stopColor: "#5684D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6721,
    style: {
      stopColor: "#1BA1E3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,48.1C70.3,49.6,49.6,70.3,48.1,96h-0.2C46.4,70.3,25.7,49.6,0,48.1v-0.2C25.7,46.4,46.4,25.7,47.9,0h0.2 C49.6,25.7,70.3,46.4,96,47.9V48.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGeminiProLogo);
export default __webpack_public_path__ + "static/media/google-gemini-pro-logo.2edd82522ba4bd7582c32fa092f2f0ec.svg";
export { ForwardRef as ReactComponent };